import 'bootstrap/dist/css/bootstrap.min.css';
import 'datatables.net';
import 'datatables.net-buttons';
import 'datatables.net-buttons-dt/css/buttons.dataTables.min.css';
import 'datatables.net-buttons/js/buttons.colVis';
import 'datatables.net-buttons/js/buttons.html5';
import 'datatables.net-buttons/js/buttons.print';
import axios from 'axios';
import $ from 'jquery';
import Swal from 'sweetalert2';
import React, { useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { baseurl, WEBSITE_URL } from '../utility/helper';
import { rupee, formatDate } from '../utility/instituteHelpers';
import '../assets/css/Institute.css';

// const WEBSITE_URL = process.env.REACT_APP_WEBSITE_URL || 'https://mensaindia.org';
const INSTITUTE_TESTS_LINK = `${WEBSITE_URL}/InstituteTests`;

const InstituteList = () => {
  const navigate = useNavigate();

  const copyLink = () => {
    navigator.clipboard?.writeText(INSTITUTE_TESTS_LINK);
    Swal.fire({ toast: true, position: 'top-end', icon: 'success', title: 'Link copied', showConfirmButton: false, timer: 1500 });
  };
  const tableRef = useRef(null);

  const fetchInstitutes = async () => {
    try {
      const res = await axios.get(`${baseurl}/admin/institutes`);
      renderTable(res.data || []);
    } catch (err) {
      console.error('Error fetching institutes:', err);
    }
  };

  const renderTable = (data) => {
    const el = tableRef.current;
    if (!el) return;

    if ($.fn.DataTable.isDataTable(el)) {
      const t = $(el).DataTable();
      t.clear();
      t.rows.add(data);
      t.draw();
      return;
    }

    $(el).DataTable({
      dom: 'Blfrtip',
      pageLength: 25,
      lengthMenu: [[10, 25, 50, 100, 250, 500, -1], [10, 25, 50, 100, 250, 500, 'All']],
      buttons: [
        { extend: 'copyHtml5', className: 'btn btn-primary dttable', exportOptions: { columns: ':visible' } },
        { extend: 'excelHtml5', className: 'btn btn-primary dttable', exportOptions: { columns: ':visible' } },
        { extend: 'csvHtml5', className: 'btn btn-primary dttable', exportOptions: { columns: ':visible' } },
        { extend: 'pdfHtml5', className: 'btn btn-primary dttable', exportOptions: { columns: ':visible' } },
        { extend: 'print', className: 'btn btn-primary dttable', exportOptions: { columns: ':visible' } },
      ],
      data,
      columns: [
        { data: 'institute_id', title: 'ID' },
        { data: 'name', title: 'Name' },
        { data: 'location', title: 'Location' },
        { data: 'approved_fee', title: 'Approved Fee', render: (d) => rupee(d) },
        { data: 'status', title: 'Status' },
        { data: 'created_at', title: 'Created', render: (d) => formatDate(d) },
      ],
      columnDefs: [
        {
          targets: 0,
          render: (data) => `<a href="#" class="edit-link" data-id="${data}">${data}</a>`,
        },
        {
          targets: 4,
          render: (data) => {
            const cls = String(data).toLowerCase() === 'active' ? 'inst-badge active' : 'inst-badge inactive';
            return `<span class="${cls}">${data || '—'}</span>`;
          },
        },
      ],
      order: [[0, 'desc']],
      initComplete: function () {
        $('.dt-length select').addClass('form-select form-select-sm');
      },
    });
  };

  useEffect(() => {
    fetchInstitutes();

    const goEdit = function (e) {
      e.preventDefault();
      navigate('/admin/InstituteForm', { state: { instituteId: $(this).data('id'), edit: true } });
    };

    $(document).off('click', '#inst-list .edit-link').on('click', '#inst-list .edit-link', goEdit);

    return () => {
      $(document).off('click', '#inst-list .edit-link');
      if (tableRef.current && $.fn.DataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable().destroy();
      }
    };
    // eslint-disable-next-line
  }, []);

  return (
    <div className="content container-fluid inst-wrap" id="inst-list">
      <center><h2><b>Institutes</b></h2></center>

      <div className="inst-card">
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
          <div className="d-flex align-items-center gap-2">
            <input className="form-control form-control-sm" style={{ width: 320 }} readOnly value={INSTITUTE_TESTS_LINK} />
            <button className="btn btn-sm btn-outline-secondary" onClick={copyLink}>Copy Link</button>
            <a className="btn btn-sm btn-success" target="_blank" rel="noreferrer"
               href={`https://wa.me/?text=${encodeURIComponent(`Register for your institute test here: ${INSTITUTE_TESTS_LINK}`)}`}>
              Share on WhatsApp
            </a>
          </div>
          <Link to="/admin/InstituteForm" state={{}}>
            <button className="btn btn-primary">
              <i className="bx bxs-plus-circle" /> Add Institute
            </button>
          </Link>
        </div>

        <div className="inst-table-scroll">
          <table ref={tableRef} className="table table-striped table-bordered" style={{ width: '100%' }}>
            <thead>
              <tr>
                <th>ID</th><th>Name</th><th>Location</th><th>Approved Fee</th>
                <th>Status</th><th>Created</th>
              </tr>
            </thead>
            <tbody></tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default InstituteList;
